import { Link } from "react-router-dom";
import { heroCover, site } from "../../../mocks/site";

export default function Hero() {
  return (
    <section className="relative flex min-h-[86vh] w-full items-center justify-center overflow-hidden">
      <img
        src={heroCover}
        alt="守护甜心动漫梦幻云端背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/30 to-background-50" />

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/80 px-4 py-1.5 text-sm text-primary-700 backdrop-blur-sm">
          <i className="ri-sparkling-2-line" />
          守护甜心 · 剧情专题站
        </span>
        <h1 className="mt-6 font-display text-4xl leading-tight text-primary-900 md:text-6xl">
          守护甜心动漫
          <span className="block text-2xl text-foreground-700 md:text-3xl">
            分集剧情 · 全集解析 · 结局详解
          </span>
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-7 text-foreground-700 md:text-lg">
          {site.description}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/episodes"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-film-line" />
            查看分集剧情
          </Link>
          <Link
            to="/ending"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-background-50/80 px-7 py-3 text-sm font-medium text-primary-700 whitespace-nowrap transition-colors hover:bg-accent-300"
          >
            <i className="ri-flag-line" />
            先看结局详解
          </Link>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-foreground-700">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-secondary-500" /> 全部分集按序梳理
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-500" /> 每集剧情速览
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500" /> 结局与设定深度解析
          </span>
        </div>
      </div>
    </section>
  );
}